import React from 'react';
import { RawTrader } from './types';
import { TONE } from './constants';

interface InsightBannerProps {
  trader: RawTrader;
}

export const InsightBanner: React.FC<InsightBannerProps> = ({ trader }) => {
  return (
    <div
      style={{
        background: TONE[trader.tone].bg,
        borderColor: TONE[trader.tone].bd,
      }}
      className="card-box p-4 md:p-4.5 flex flex-wrap gap-3 items-center justify-between mb-4 border"
    >
      <div className="flex gap-3 items-start flex-1 min-w-[300px]">
        <div
          style={{ background: TONE[trader.tone].fg }}
          className="w-2.5 h-2.5 !rounded-full mt-1.5 flex-shrink-0"
        ></div>
        <div>
          <div style={{ color: TONE[trader.tone].fg }} className="text-sm font-bold">
            {trader.ins[0]}
          </div>
          <div className="text-xs md:text-sm text-[#3F4A5A] mt-1 max-w-3xl leading-relaxed">
            {trader.ins[1]}
          </div>
        </div>
      </div>
      <div className="font-mono text-xs text-[#8B95A3]">09/09/2026 08:00 · cập nhật hằng ngày</div>
    </div>
  );
};
